import { Button } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import AddIcon from '@material-ui/icons/Add';
import { DisableComponents } from "../../../util/DisableComponentsWrapper";
import { ComponentPermissions } from "../../../../Permissions";
import useCheckPermissions from "../../../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../../../const/permissions.const";
import DisabledActionWrapper from "../../../../yoello-lib/modules/components/DisabledActionWrapper";

interface IProductListCreateButtonProps {
    onClick: () => void;
    title: string;
    isLoading?: boolean;
    buttonKey?: string;
}

/**This button will not show for epos now customers */
export function ProductListCreateButton({
    onClick,
    title,
    buttonKey,
    isLoading = false
}: IProductListCreateButtonProps) {
    const { t } = useTranslation();

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

    //@ts-ignore
    const disabledPerms: any = ComponentPermissions[buttonKey || ""]
    return <DisableComponents disabledPermissions={disabledPerms} >
        <div className="create">
            <DisabledActionWrapper
                disabled={!hasPermission}
                onDisabledClick={onFailedInteraction}
            >
                <Button
                    onClick={onClick}
                    size="large"
                    variant="contained"
                    color="primary"
                    disabled={isLoading || !hasPermission}
                    data-component-name="CREATE_NEW"
                >
                    <AddIcon />
                    {t(title)}
                </Button>
            </DisabledActionWrapper>
            
        </div>
    </DisableComponents>
}